import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { enGB, nl, de, fr } from "date-fns/locale";
import { getBrowserLanguage } from "./common";

import Service from "../modules/Translations/service";

if (!localStorage.getItem("locale")) {
  const language = getBrowserLanguage();
  localStorage.setItem("locale", language);
}

const LOCALE = localStorage.getItem("locale") !== "undefined" ? localStorage.getItem("locale") : "en-GB";

switch (LOCALE) {
  case "fr-FR":
    registerLocale(LOCALE, fr);
    break;
  case "nl-NL":
    registerLocale(LOCALE, nl);
    break;
  case "de-DE":
    registerLocale(LOCALE, de);
    break;
  default:
    registerLocale(LOCALE, enGB);
    break;
}

setDefaultLocale(LOCALE);

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en-GB",
    returnObjects: true,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    debug: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      request: async function (_options, _url, _payload, callback) {
        try {
          const response = await Service.getTranslations(LOCALE);
          callback(null, { status: response.status, data: response.data.data.translations });
        } catch (error) {
          console.log("Error getting translations", error);
          callback(error);
        }
      },
    },

    react: {
      wait: true,
      useSuspense: false,
    },
  });

export default i18n;
